import { render, staticRenderFns } from "./SocialDatePicker.vue?vue&type=template&id=9e480474&"
import script from "./SocialDatePicker.vue?vue&type=script&lang=js&"
export * from "./SocialDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports